import { hasCapability, type User } from "../base";

export const ratebook = {
  publish: (user: User) => hasCapability(user, "ratebook.publish"),
  create: (user: User) => hasCapability(user, "ratebook.create"),
  update: (user: User) => hasCapability(user, "ratebook.update"),
  read: (user: User) => hasCapability(user, "ratebook.read"),
  /** View draft ratebooks, import summaries, and other unpublished data */
  readDrafts: (user: User) => hasCapability(user, "ratebook.readDrafts"),
};

export const laborbook = {
  read: (user: User) => hasCapability(user, "laborbook.read"),
  update: (user: User) => hasCapability(user, "laborbook.update"),
  readDrafts: (user: User) => hasCapability(user, "laborbook.readDrafts"),
};
